<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">BIENES INMUEBLES (SITUACIÓN ACTUAL) </legend>
        </div>
      </div>
      <div class="form-group col-12">
        <label class="control-label">¿ Tiene bienes inmuebles ? <b-button class="btn-popover" v-b-popover.hover.top="info.inmuebles"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de bienes declarados a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. </div>
        </div>

        <div class="row">
          <legend>Bienes del declarante, pareja y/o dependientes económicos</legend>
          <div class="form-group col-6">
            <label class="control-label">Tipo de inmueble <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_bien_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="inmueble" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipo_bien_id">
              <el-option v-for="option in tipos_inmuebles" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('inmueble')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_bien_id == 4">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique_inmueble" v-validate="'required'" v-model="form_item.especifique_inmueble" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique_inmueble')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Titular del inmueble <b-button class="btn-popover" v-b-popover.hover.top="info.titular_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" placeholder="Seleccione una opción" name="titular_id" v-validate="'required'" v-model="form_item.titular_id">
              <el-option v-for="option in titular_adeudo" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('titular_id')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Porcentaje de propiedad del declarante conforme a escrituración o contrato <b-button class="btn-popover" v-b-popover.hover.top="info.porcentaje_propiedad"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="porcentaje_propiedad_propiedad" v-validate="'required|between:0,100'" v-model="form_item.porcentaje_propiedad" controls-position="right" :step="5" :min="0" :max="100"></el-input-number>
            <small class="text-danger">{{ errors.first('porcentaje_propiedad_propiedad')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Superficie del terreno ( m<sup>2</sup> ) <b-button class="btn-popover" v-b-popover.hover.top="info.superficie_terreno"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="superficie_terreno" v-validate="'required|decimal:0'" v-model="form_item.superficie_terreno" controls-position="right" :min="0"></el-input-number>

            <!-- <input name="superficie_terreno" v-validate="'required|min:1'" class="form-control" type="number" min="0" v-model="form_item.superficie_terreno" placeholder="Superficie del terreno"> -->
            <small class="text-danger">{{ errors.first('superficie_terreno')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Superficie de construcción ( m<sup>2</sup> ) <b-button class="btn-popover" v-b-popover.hover.top="info.superficie_construccion"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="superficie_construccion" v-validate="'required|decimal:0'" v-model="form_item.superficie_construccion" controls-position="right" :min="0"></el-input-number>

            <!-- <input name="superficie_construccion" v-validate="'required|min:1'" class="form-control" type="number" min="0" v-model="form_item.superficie_construccion" placeholder="Superficie de construcción"> -->
            <small class="text-danger">{{ errors.first('superficie_construccion')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Tercero <b-button class="btn-popover" v-b-popover.hover.top="info.tercero"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="1">Persona física</p-radio>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Nombre del tercero o terceros <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_tercero" v-validate="'required'" v-model="form_item.nombre_tercero" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">RFC del tercero <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_tercero" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_tercero" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_tercero')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de adquisición <b-button class="btn-popover" v-b-popover.hover.top="info.forma_adquisicion_id"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="forma_adquisicion_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.forma_adquisicion_id">
              <el-option v-for="option in adquisiciones" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('forma_adquisicion_id')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Forma de pago <b-button class="btn-popover" v-b-popover.hover.top="info.forma_pago"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="forma_pago" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.forma_pago">
              <el-option v-for="option in pagos" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('forma_pago')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.transmisor"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="transmisor" class="d-inline-block" v-validate="'required'" v-model="form_item.transmisor" label="1">Persona física</p-radio>
            <p-radio name="transmisor" class="d-inline-block" v-validate="'required'" v-model="form_item.transmisor" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('transmisor')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre del transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_denominacion_quien_adquirio"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_denominacion_quien_adquirio" v-validate="'required'" v-model="form_item.nombre_denominacion_quien_adquirio" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_denominacion_quien_adquirio')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC del transmisor <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_quien_adquirio"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_quien_adquirio" v-validate="'required|uppercase|max:13'" v-model="form_item.rfc_quien_adquirio" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_quien_adquirio')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Relación del transmisor de la propiedad con el titular del inmueble <b-button class="btn-popover" v-b-popover.hover.top="info.relacion"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="relacion" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.relacion_persona_adquirio_id">
              <el-option v-for="option in transmisores" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('relacion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.relacion_persona_adquirio_id == 20">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="relacion_especificar" v-validate="'required'" v-model="form_item.relacion_especificar" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('relacion_especificar')}}</small>
          </div>
          <div class="form-group col-6 ">
            <label class="control-label">Valor de adquisición <b-button class="btn-popover" v-b-popover.hover.top="info.valor_adquisicion+' '+info.tipo_moneda"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="valor_adquisicion" v-validate="'required|min:1'" type="number" min="0" class="text-right" v-model="form_item.precio_adquisicion_valor" placeholder="0" @keyup.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.precio_adquisicion_valor)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.precio_adquisicion_moneda_id">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.precio_adquisicion_moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <small class="text-danger">{{ errors.first('valor_adquisicion')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">¿El valor de adquisición conforme a? <b-button class="btn-popover" v-b-popover.hover.top="info.valor_conforme"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="valor_conforme" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.valor_conforme">
              <el-option v-for="option in valores_inmueble" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('valor_conforme')}}</small>
          </div>
          <!--
          <div class="form-group col-6">
            <label class="control-label">Valor de adquisición <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.precio_adquisicion_valor" placeholder="Monto mensual">
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de moneda <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_moneda"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="tipo_moneda" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.precio_adquisicion_moneda_id">
              <el-option v-for="option in monedas" class="select-default" :value="option.id" :label="option.moneda" :key="option.moneda">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_moneda') }}</small>
          </div>
          -->
          <div class="form-group col-6">
            <label class="control-label">Fecha de Adquisición del inmueble <b-button class="btn-popover" v-b-popover.hover.top="info.fecha_adquisicion"><i class="far fa-question-circle"></i></b-button></label>
            <div class="form-group">
              <el-date-picker name="fecha_adquisicion" v-validate="'required|min:1'" type="date" v-model="form_item.fecha_adquisicion" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
            </div>
            <small class="text-danger">{{ errors.first('fecha_adquisicion')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Datos del registro público de la propiedad: Folio real u otro dato que permita su identificación <b-button class="btn-popover" v-b-popover.hover.top="info.numero_registro_publico"><i class="far fa-question-circle"></i></b-button></label>
            <input name="numero_registro_publico" v-validate="'required|min:1'" class="form-control" type="text" v-model="form_item.numero_registro_publico" placeholder="Número de registro público">
            <small class="text-danger">{{ errors.first('numero_registro_publico')}}</small>
          </div>
          <domicilio v-model="n_domicilio" :vista="false" :popover="info.lugar" titulo="/ Ubicación del Inmueble">
          </domicilio>
          <div class="form-group col-6">
            <label class="control-label">En caso de baja del inmueble incluir motivo <b-button class="btn-popover" v-b-popover.hover.top="info.motivo_baja"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="motivo_baja" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.motivo_baja">
              <el-option v-for="option in bajas_inmueble" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
            <!-- <small class="text-danger">{{ errors.first('motivo_baja')}}</small> -->
          </div>
          <div class="form-group col-6" v-if="form_item.motivo_baja == 4">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique_baja" v-validate="'required'" v-model="form_item.especifique_baja" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique_baja')}}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.titular_id="{ item }">
                <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
              </template>
              <template v-slot:item.tipo_bien_id="{ item }">
                <div>{{filterCatalog(item.tipo_bien_id,tipos_inmuebles)}}</div>
              </template>

            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* var moment = require('moment') */
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: null,
        add_item: false,
        edit_item: null,
        bandera: '0',
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Tipo de inmueble',
          value: 'tipo_bien_id',
          align: 'center',
        }, {
          text: 'Titular del inmueble',
          value: 'titular_id',
          align: 'center',
        }, {
          text: 'Fecha de Adquisición',
          value: 'fecha_adquisicion',
          align: 'center',
        }, {
          text: 'Datos del registro público de la propiedad',
          value: 'numero_registro_publico',
          align: 'center',
        }, {
          text: 'Aclaraciones / Observaciones',
          value: 'observaciones',
          align: 'center',
        }, ],
        info: {
          inmuebles: 'Reportar aquellos bienes que conforme a la normatividad aplicable se consideran inmuebles. Para la declaración de inicio reportar la situación de los bienes inmuebles a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de los bienes inmuebles del año inmediato anterior. Para la declaración de conclusión reportar la situación de los bienes inmuebles a la fecha de conclusión del empleo, cargo o comisión.',
          tipo_bien_id: 'Seleccionar el tipo de bien inmueble que se declara: casa, departamento, edificio, local comercial, bodega, palco, rancho, terreno y otro, especifique.',
          titular_id: 'Seleccionar alguna de las opciones del catálogo desplegable.',
          porcentaje_propiedad: 'En caso de que el Declarante sea el único dueño deberá poner el cien por ciento, de no ser así señalará el porcentaje_propiedad que le corresponda, de acuerdo a la escritura o contrato.',
          superficie_terreno: 'Señalar en metros cuadrados la superficie total del terreno.',
          superficie_construccion: 'Señalar en metros cuadrados la superficie total de construcción.',
          tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
          nombre_tercero: 'En caso de copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En el caso de personas morales establecer los doce dígitos.',
          forma_adquisicion_id: 'Seleccionar alguna de las opciones del catálogo.',
          forma_pago: 'Seleccionar la forma en que realizó el pago para adquirir el inmueble, en caso de que no haya pagado por el mismo, indicará no aplica.',
          transmisor: 'Seleccionar si es persona física o persona moral.',
          nombre_denominacion_quien_adquirio: 'Escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc_quien_adquirio: 'En caso de personas físicas señalar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          relacion: 'Seleccionar alguna de las opciones del catálogo desplegable y en caso de seleccionar otro especificar.',
          valor_adquisicion: 'Proporcionar el monto de adquisición, conforme al documento con el que se acredita la compra del bien inmueble.',
          valor_conforme: 'Seleccionar si fue conforme a escritura pública, conforme a sentencia o contrato.',
          fecha_adquisicion: 'Señalar la fecha de adquisición del inmueble, conforme al documento con el que se acredita la propiedad.',
          tipo_moneda: 'Seleccionar la moneda relativa al valor de adquisición.',
          numero_registro_publico: 'Señalar el número de escritura pública, folio real o cualquier dato que lo identifique.',
          motivo_baja: 'Elegir la razón por la cual se da de baja venta, donación, siniestro u otro. Especifique.',
          lugar: 'Proporcionar los datos relativos al lugar donde se ubica el inmueble declarado. Seleccionando si es en México o en el extranjero. En caso de seleccionar México, proporcionar los siguientes datos: calle, número exterior, número interior (si aplica), colonia o localidad, municipio o alcaldía, entidad federativa y código postal. En caso de seleccionar extranjero, proporcionar los siguientes datos: calle, número exterior, número interior (si aplica), ciudad/localidad, estado o provincia, país, código postal.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
        /*             */
        n_domicilio: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        },
      };
    },

    computed: {
      terceros() {
        if (this.form_item) {
          if (this.form_item.titular_id) {
            var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
            return arr.includes(this.form_item.titular_id);
          }
        }
        return false;
      },
      getSigno() {
        var signo = "$";
        var val = this.form_item.precio_adquisicion_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.form_item.precio_adquisicion_moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },

    },
    watch: {
      n_domicilio: {
        handler: function (val, oldVal) {
          if (this.n_domicilio) {
            this.form_item.domicilio_bien_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.form_item.domicilio_bien_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.form_item.domicilio_bien_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.form_item.domicilio_bien_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.form_item.domicilio_bien_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.form_item.domicilio_bien_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.form_item.domicilio_bien_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.form_item.domicilio_bien_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.form_item.domicilio_bien_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.form_item.domicilio_bien_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          }
        },
        immediate: true,
        deep: true
      },

    },
    methods: {
      /* getSignoDos(val = "97") {
        var signo = "$";
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },

      getLocalidad(index) {
        var resp = "";
        if (this.localidades) {
          this.localidades.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_loc;
              return resp;
            }
          });
        }
        return resp;
      },
      getMunicipio(index) {
        var resp = "";
        if (this.municipios) {
          this.municipios.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_mun;
              return resp;
            }
          });
        }
        return resp;
      },
      */
      editDomicilio() {
        if (this.form_item) {
          this.n_domicilio.pais_id = this.form_item.pais ? this.form_item.pais : 150;
          this.n_domicilio.entidadF = this.form_item.domicilio_bien_entidad_federativa_id ? this.form_item.domicilio_bien_entidad_federativa_id : "";
          this.n_domicilio.municipio = this.form_item.domicilio_bien_municipio_id ? this.form_item.domicilio_bien_municipio_id : "";
          this.n_domicilio.localidad = this.form_item.domicilio_bien_localidad_id ? this.form_item.domicilio_bien_localidad_id : "";
          this.n_domicilio.cp = this.form_item.domicilio_bien_cp ? this.form_item.domicilio_bien_cp : "";
          this.n_domicilio.vialidad_nombre = this.form_item.domicilio_bien_vialidad_nombre ? this.form_item.domicilio_bien_vialidad_nombre : "";
          this.n_domicilio.vialidad = this.form_item.domicilio_bien_vialidad_tipo ? this.form_item.domicilio_bien_vialidad_tipo : "";
          this.n_domicilio.ext = this.form_item.domicilio_bien_numext ? this.form_item.domicilio_bien_numext : "";
          this.n_domicilio.int = this.form_item.domicilio_bien_numint ? this.form_item.domicilio_bien_numint : "";
          this.n_domicilio.colonia = this.form_item.domicilio_bien_colonia ? this.form_item.domicilio_bien_colonia : "";
        }
      },
      initDomicilio() {
        this.n_domicilio = {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        };
      },
      showItem() {
        this.add_item = true;
        if (!this.form_item.domicilio_bien_pais_id) {
          //El id Mexico es 150
          this.form_item.domicilio_bien_pais_id = 150;
        }
        this.form_item.precio_adquisicion_moneda_id = 97;
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.form_item = {};
        this.initDomicilio();
        this.edit_item = false;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              //this.checkDomicilio();
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("bienes_inmuebles", this.form_item).then(
                response => {
                  this.StepOk("Guardado");
                  //if (this.edit_item === undefined || this.edit_item === null) {
                  if (!this.edit_item) {
                    this.table_list.unshift({
                      ...response.data.response
                    });
                  } else {
                    let index = this.table_list.map(u => {
                      return u.id;
                    }).indexOf(response.data.response.id);
                    this.table_list.splice(index, 1, response.data.response);
                  }
                  this.cancelEdit();
                }, error => {
                  this.StepError(error);
                });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.scrolling();
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = true;
        this.form_item = {
          ...item
        };
        this.editDomicilio();
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("bienes_inmuebles/" + item.id).then(
              response => {
                let index = this.table_list.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.table_list.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      checkDomicilio() {
        if (this.n_domicilio) {
          this.form_item.domicilio_bien_pais_id = this.n_domicilio.pais;
          this.form_item.domicilio_bien_entidad_federativa_id = this.n_domicilio.entidadF;
          this.form_item.domicilio_bien_municipio_id = this.n_domicilio.municipio;
          this.form_item.domicilio_bien_localidad_id = this.n_domicilio.localidad;
          this.form_item.domicilio_bien_cp = this.n_domicilio.cp;
          this.form_item.domicilio_bien_vialidad_nombre = this.n_domicilio.vialidad_nombre;
          this.form_item.domicilio_bien_vialidad_tipo = this.n_domicilio.vialidad;
          this.form_item.domicilio_bien_numext = this.n_domicilio.ext;
          this.form_item.domicilio_bien_numint = this.n_domicilio.int;
          this.form_item.domicilio_bien_colonia = this.n_domicilio.colonia;
        }
      },
      /* validate() {
        return this.$validator.validateAll();
      },
      setLocalidades() {
        this.localidades = [];
        this.table_list.forEach((item) => {
          if (item.domicilio_bien_localidad_id) {
            this.$http.get('localidades/localidad/' + item.domicilio_bien_localidad_id).then(
              response => {
                this.localidades.push(response.data.localidad);
              },
              error => {
                this.Err(error);
              }
            );
          }
        });
      },
      isNumber(n) {
        //console.log(n);
        n.target.value = n.target.value.replace(/[^\d.-]/g, '');
      },
      valida() {
        var dom = false;
        'lugarv', 'entidadv', 'paisv', 'localidadv', 'coloniav', 'tvialidadv', 'vialidadv', 'municipiov',
        'cpv', 'extv'
        this.$refs.Domicilio.validate(['lugarv', 'entidadv', 'paisv', 'localidadv', 'coloniav', 'tvialidadv', 'vialidadv', 'municipiov',
          'cpv', 'extv'
        ]).then(response => {
          if (response.every(this.isTrue)) { //si
            dom = true;
          }
        });
        this.$validator.validate().then(valid => {
          if (valid && dom) {
            this.addItem();
          } else {
            this.StepW("Hay campos sin completar");


          }
        });
      },
      isTrue(currentValue) {
        return currentValue;
      } */
    },
    created() {
      this.ip_id = this.getKey('uid');
      //this.getLocalidades(97250);
      this.$http.get("bienes_inmuebles/" + this.ip_id).then(
        response => {
          this.table_list = response.data.response;
          if (this.table_list) {
            if (this.table_list.length > 0) {
              this.bandera = '1';
            }
          }
        });
    },
    mounted() {
      this.checkCatalogs();
      this.form_item.domicilio_bien_pais_id = 150;
    },
  };

</script>
<style>
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance: textfield !important;
  }

  input[type="number"] {
    background: transparent !important;
    border: none !important;
    border-bottom: 1px solid #66615b !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Activos/BienesInmuebles.vue